<template>
	<div class='deal-container'>
		<div class='deal' @click='clickHandle'>
			<header class='people-picture' :style='{backgroundImage: `url(${(deal.image)?(deal.image):("/assets/img/placeholder.png")})`}'></header>
			<div class='deal-price'>$ {{deal.home_price | formatPrice}}</div>
		</div>
	</div>
</template>

<script>
import deal from '__jsVueSections/ListOfDeals/components/mixins/deal';
export default {
	name:   'Deal',
	mixins: [deal],
	props:  {
		link: {
			type:    String,
			default: ''
		},
		showLink: {
			type:    Boolean,
			default: false
		}
	},
	computed: {
		href() {
			if (this.showLink) {
				return (this.link) ? (this.link) : (`/deals/${this.deal.id}/edit`);
			}
			return '';
		}
	},
	methods: {
		clickHandle() {
			if (this.href) {
				window.location.href = this.href;
			}
			this.$emit('click', this.deal.id);
		}
	}
};
</script>
